import { backOff } from "exponential-backoff";
import { OmmuseClient } from "../proto/api_grpc_web_pb";
import {
  EnterpriseDetails,
  InitialUserState,
  RegisterInitialUserRequest,
  RegisterMajorTrialSubscriptionRequest,
  RegisterMinorSubscriptionRequest,
  RegisterUserRequest,
} from "../proto/api_pb";
import { blobToBase64 } from "../utils/Base64Util";
import { awaitableUploadToS3 } from "../utils/S3Utils";
import { Profile } from "../pages/ProfileSettings/types";
import { User } from "@auth0/auth0-react";

const ASSETS_URL = process.env.REACT_APP_ASSET_S3_BUCKET_URL!;

export const registerUser = async (
  profile: Profile,
  profilePicBlob: Blob | null,
  userId: string,
  user: User | undefined,
  profilePicFile: File | null,
  accessToken: string,
  awsAccessKeyId: string | undefined,
  awsSecretAccessKey: string | undefined,
  awsSessionToken: string | undefined,
  allEnterprises: EnterpriseDetails[]
): Promise<unknown> => {
  const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
  const request = new RegisterUserRequest();
  let profilePictureString = profile.profilePic;
  if (profilePicBlob && profilePicBlob.size > 0) {
    profilePictureString = (await blobToBase64(profilePicBlob)) as string;
    profilePictureString = profilePictureString.split(",")[1];
  }
  request.setUserId(userId);
  request.setFirstName(profile.firstName.trim());
  request.setLastName(profile.lastName.trim());
  request.setUsername(profile.username.trim());
  request.setEmail(user?.email ?? "");
  request.setGenresList(profile.genres);
  // request.addWalletAddresses(profile?.connectedWallet ?? "");
  request.setSkillsList(profile.skills);
  request.setBio(profile.bio);
  request.setApprovedTermsTimestamp(Math.floor(new Date().getTime() / 1000));
  request.setEnterpriseDetailsList(allEnterprises)

  if (profilePicBlob && profilePicBlob.size > 0) {
    try {
      const key = await awaitableUploadToS3(
        userId,
        profilePicFile!,
        `profile/${profile.username}`,
        profilePicFile!.type,
        awsAccessKeyId,
        awsSecretAccessKey,
        awsSessionToken,
        () => { }
      );
      profilePictureString = ASSETS_URL + "/" + key;
    } catch (error) {
      console.log(error);
      alert(error);
    }
  }
  request.setProfilePicture(profilePictureString);

  const metadata = {
    Authorization: `${accessToken}`,
    "Access-Control-Allow-Origin": "*",
  };
  return await backOff(
    () =>
      new Promise((resolve, reject) => {
        ommuseClient.registerUser(request, metadata, function (err, response) {
          if (err) {
            console.log("register user error");
            console.log(err.message);
            reject(err);
          } else {
            console.log("registered successfully");
            resolve(response);
          }
        });
      }),
    {
      numOfAttempts: 3,
      jitter: "full",
    }
  );
};

export const registerInitialUser = async (
  email: string | undefined,
  accessToken: string
): Promise<unknown> => {
  const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
  const request = new RegisterInitialUserRequest();
  request.setEmail(email ?? "");
  request.setState(InitialUserState.INITIAL_USER_STATE_PENDING);
  const metadata = {
    Authorization: `${accessToken}`,
    "Access-Control-Allow-Origin": "*",
  };
  return await backOff(
    () =>
      new Promise((resolve, reject) => {
        ommuseClient.registerInitialUser(
          request,
          metadata,
          function (err, response) {
            if (err) {
              console.log("register initial user error");
              console.log(err.message);
              reject(err);
            } else {
              console.log("registered initial user successfully");
              resolve(response);
            }
          }
        );
      }),
    {
      numOfAttempts: 3,
      jitter: "full",
    }
  );
};

export const registerMinorSubscription = async (
  userId: string | undefined,
  accessToken: string
): Promise<unknown> => {
  const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
  const request = new RegisterMinorSubscriptionRequest();
  request.setUserId(userId ?? "");
  const metadata = {
    Authorization: `${accessToken}`,
    "Access-Control-Allow-Origin": "*",
  };
  return await backOff(
    () =>
      new Promise((resolve, reject) => {
        ommuseClient.registerMinorSubscription(
          request,
          metadata,
          function (err, response) {
            if (err) {
              console.log("register minor sub error");
              console.log(err.message);
              reject(err);
            } else {
              console.log("registered minor sub successfully");
              resolve(response);
            }
          }
        );
      }),
    {
      numOfAttempts: 3,
      jitter: "full",
    }
  );
};
export const registerMajorTrialSubscription = async (
  userId: string | undefined,
  accessToken: string
): Promise<unknown> => {
  const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
  const request = new RegisterMajorTrialSubscriptionRequest();
  request.setUserId(userId ?? "");
  const metadata = {
    Authorization: `${accessToken}`,
    "Access-Control-Allow-Origin": "*",
  };
  return await backOff(
    () =>
      new Promise((resolve, reject) => {
        ommuseClient.registerMajorTrialSubscription(
          request,
          metadata,
          function (err, response) {
            if (err) {
              console.log("register major sub error");
              console.log(err.message);
              reject(err);
            } else {
              console.log("registered major sub successfully");
              resolve(response);
            }
          }
        );
      }),
    {
      numOfAttempts: 3,
      jitter: "full",
    }
  );
};
